import { useMutation } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';

export const useUploadCoverImage = () => {
  return useMutation({
    mutationFn: likedFolderService.uploadCoverImage,
  });
};
